import { combineReducers } from "redux";

import * as merchantId from "./merchantId";
import * as campaignId from "./campaignId";

export const reducer = combineReducers({
  campaignId: campaignId.reducer,
  merchantId: merchantId.reducer,
});

export interface StoreState {
  campaignId: campaignId.StoreState;
  merchantId: merchantId.StoreState;
}
